import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrop = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M21 16h-3V8.56A2.56 2.56 0 0015.44 6H8V3a1 1 0 10-2 0v3H3a1 1 0 100 2h3v7.44A2.56 2.56 0 008.56 18H16v3a1 1 0 002 0v-3h3a1 1 0 000-2zM8.56 16a.56.56 0 01-.56-.56V8h7.44c.31 0 .56.25.56.56V16H8.56z",
			fillRule: "nonzero"
		})
	})
});
export { SvgCrop as ReactComponent };
